import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Footer } from "@/components/layout/Footer";
import { Card } from "@/components/ui/Card";
import { Logo } from "@/components/ui/Logo";
import { hasUserCookie } from "@/lib/auth-cookie";
import { brand } from "@/theme/themes";

export const Route = createFileRoute("/_auth")({
	beforeLoad: () => {
		// Bewusst ohne ensureSessionMarker: /login und /register sollen ohne jeden
		// Backend-Kontakt rendern, und bei unbekanntem Marker ist "zeig die
		// Login-Seite" das richtige und sichere Verhalten. Nicht vereinheitlichen.
		if (hasUserCookie()) {
			throw redirect({ to: "/search" });
		}
	},
	component: AuthLayout,
});

function AuthLayout() {
	return (
		<div className="min-h-screen bg-background flex flex-col">
			<div className="flex-1 flex flex-col items-center justify-center p-4">
				<div className="w-full max-w-md">
					<div className="flex flex-col items-center gap-3 mb-8">
						<a href="/" className="no-underline">
							<Logo size={48} />
						</a>
						<span className="text-2xl font-bold bg-gradient-to-r from-primary to-primary-gradient-end bg-clip-text text-transparent">
							{brand.siteName}
						</span>
					</div>
					<Card glass padding="lg" className="!overflow-visible">
						<Outlet />
					</Card>
				</div>
			</div>
			<Footer minimal />
		</div>
	);
}
